/** Image extensions → JSW attachment TYPE "P"; all others → "D". */
const IMAGE_EXTENSIONS = new Set([
  "gif",
  "png",
  "jpg",
  "jpeg",
  "tif",
  "tiff",
  "bmp",
]);

const ATTACH_TYPE_BY_GROUP: Record<string, string> = {
  contactDetails: "Business Approval",
  vendorName: "Commercial Registration certificate",
  address: "GST Registration Certificate",
  "field-GST_NUMBER": "GST Registration Certificate",
  "field-MSME_NO": "MSME Certificate",
  "field-PAN_NUMBER": "PAN Card",
};

const BANK_GROUP_PREFIX = "bank-";

export function attachTypeForDocumentGroup(groupId: string): string | null {
  if (ATTACH_TYPE_BY_GROUP[groupId]) {
    return ATTACH_TYPE_BY_GROUP[groupId];
  }
  if (groupId.startsWith(BANK_GROUP_PREFIX)) {
    return "Cancelled Copy of Cheque";
  }
  return null;
}

export function attachmentTypeForFile(ext: string): "P" | "D" {
  const normalized = (ext || "").toLowerCase().replace(/^\./, "");
  return IMAGE_EXTENSIONS.has(normalized) ? "P" : "D";
}

export function fileExtension(fileName: string): string {
  const name = fileName || "";
  const dot = name.lastIndexOf(".");
  return dot >= 0 ? name.slice(dot + 1).toLowerCase() : "";
}

/** Raw base64 payload (no data-URL prefix). */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("Unable to read file"));
        return;
      }
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error || new Error("Unable to read file"));
    reader.readAsDataURL(file);
  });
}
